class HeaderSkipLink {

    /**
     * constructor
     */
    constructor() {
        this.$skipLinkButton = document.querySelector('[data-skip-link]')
        this.$mainContent = document.querySelector('#main-content')
    }

    /**
     * setup function to add event listener
     */
    setup() {
        this.$skipLinkButton.addEventListener('click', () =>
                this.handleSkipLinkClick()
            );
    }

    /**
     * Focuses on main content when invoked
     */
    handleSkipLinkClick() {
        this.$mainContent.focus()
    }
}

export default new HeaderSkipLink();